import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import Vuetify from 'vuetify'
import VueTimers from 'vue-timers'

Vue.use(VueTimers)

Vue.use(Vuetify, {
  rtl: true
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
